import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { AiroService } from "../../services/airo.service";
import { MatExpansionPanel } from "@angular/material/expansion";
import { ComplianceService } from "../../services/compliance.service";
import { MatDialog } from "@angular/material/dialog";
import { AiroDataDialogComponent } from "../airo-data-dialog/airo-data-dialog.component";
import { environment } from "../../../../environments/environment";
import { AIRO_LOCKED_TEXT, AIRO_QUERY_VERSE, isAiroLicensed } from "../../services/license.service";

@Component({
  selector: "app-airo-chat",
  templateUrl: "./airo-chat.component.html",
  styleUrls: ["./airo-chat.component.scss"],
})
export class AiroChatComponent {
  @ViewChild("recentPanel") recentPanel!: MatExpansionPanel;
  isLoading: boolean = false;
  query: string = "";
  summary: string = "";
  links: { name: string; url: string }[] = [];
  recentQueries: any = [];
  recentAiroDataQueries: any = [];
  generatedAt: any;
  enterpriseDetails: any;
  airoResp: any;
  selectedMode: string = "airo-web";
  defaultRepoId: any = null;
  defaultRepoName: string = "";
  // Ask Airo needs the tenant's Airo licence to include Query Verse.
  readonly airoLocked = !isAiroLicensed(AIRO_QUERY_VERSE);
  readonly airoLockedText = AIRO_LOCKED_TEXT;

  constructor(
    private readonly airoService: AiroService,
    private readonly cdr: ChangeDetectorRef,
    private readonly complianceService: ComplianceService,
    private readonly dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (this.airoLocked) return;
    this.getRecentConversations();
    this.getAiroDefaultRepo();
  }

  getAiroDefaultRepo() {
    this.complianceService.getAiroRepos().subscribe((res: any) => {
      const airoRepos = res.data;
      this.airoService.getDefaultRepoName().subscribe((res: any) => {
        const defaultRepo = airoRepos.find(
          (repo: any) => repo.name === res.value
        );
        this.defaultRepoId = defaultRepo?.id;
        this.defaultRepoName = defaultRepo?.name;
        this.getAiroDataConversations();
      });
    });
  }

  onModeChange(event: any) {
    console.log("Captured Mode:", this.selectedMode);

    if (this.selectedMode === "airo-data") {
      // Logic for Data Mode: e.g., clear previous web results
      this.summary = "";
    } else {
      // Logic for Web Mode
    }
  }

  getAiroDataConversations() {
    this.airoService
      .getAiroDataConversations(this.defaultRepoId)
      .subscribe((res: any) => {
        this.recentAiroDataQueries = res.data;
      });
  }

  openAiroDataDialog() {
    const dialog = this.dialog.open(AiroDataDialogComponent, {
      hasBackdrop: true,
      width: "70vw",
      minHeight: "80vh",
      disableClose: true,
      autoFocus: false,
      data: {
        query: this.query,
        repoId: this.defaultRepoId,
      },
    });
  }

  onAskAiro() {
    if (this.airoLocked) return;
    if (!this.query.trim()) return;

    if (this.selectedMode === "airo-data") {
      // this.openAiroDataDialog();
      window.open(
        `${environment.airoFrontendURL}/verse/structured/home?project_name=${this.defaultRepoName}&query=${encodeURIComponent(this.query)}`,
        "_blank"
      );
      return;
    }

    this.isLoading = true;
    this.summary = "";
    this.links = [];

    const payload = {
      query_string: this.query,
    };

    this.airoService.getDirectWebResult(payload).subscribe(
      (res: any) => {
        this.airoResp = res.data;
        this.processResponse(res.data);
        this.isLoading = false;
        this.getRecentConversations();
      },
      (err: any) => {
        console.error("Error fetching web result:", err);
        this.isLoading = false;
      }
    );
  }

  processResponse(res: any) {
    if (res.answer) {
      this.summary = res.answer;
    } else {
      const acceptableKeys = [
        "title",
        "context",
        "problem_statement",
        "description",
      ];
      this.summary = acceptableKeys
        .filter((key) => res[key])
        .map((key) => res[key])
        .join("\n\n");
    }

    this.generatedAt = res.generated_at;

    this.links = (res.data || []).map((item: any) => ({
      name: item.name,
      url: item.url,
    }));
  }

  loadQuery(q: any) {
    if (this.selectedMode === "airo-data") {
      this.query = q.user_query;
      return;
    } else {
      this.query = q.query;
      this.airoResp = q.response;
    }
    this.summary = "";
    this.links = [];
    this.generatedAt = null;
    this.cdr.detectChanges();
    this.processResponse(q.response);
    this.recentPanel.close();
  }

  getRecentConversations() {
    this.airoService
      .getPreviousConversations("direct")
      .subscribe((res: any) => {
        this.recentQueries = res.data;
      });
  }

  get queriesToShow(): any[] {
    return this.selectedMode === "airo-web"
      ? this.recentQueries
      : this.recentAiroDataQueries;
  }
}
